const ProfileBanners = {
  computed: {
    ...Vuex.mapState(['user', 'profile']),
    bannerToShow: function () {
      console.log(this.$route.path, this.user.jobs, this.profile.type);

      if (this.$route.path === '/inscripciones') {
        //Help to apply for jobs
        return 'bannerForApplicants';
      }

      if (this.user.jobs > 0 && this.$route.path !== '/empleo/nuevo') {
        //CTA employers to post another job
        return 'bannerForEmployers';
      }

      if (this.user.jobs === 0 && this.$route.path !== '/inscripciones') {
        //CTA to post view recommendations
        return 'bannerForEmployees';
      }

      if (!this.profile.type && this.$route.path !== '/empleo/nuevo') {
        //CTA for new users to post a job
        return 'bannerForNewUsers';
      }
    },
  },
  created: function () {
    this.$dmtk.profile.get().then((data) => {
      this.$store.commit('set', data);
    });
  },
  methods: {
    maybe(n) {
      return Math.floor(Math.random() * n) === 0;
    },
    openHelp() {
      window.open('/ayuda/como-inscribirse-en-una-oferta-de-empleo/');
    },
  },
  template: `
      <div class="uk-margin-top" v-if="!$route.path.includes('/mensajes')">
        
        <div
            id="profile-banner-202309"
            class="banner-panel"
            @click="$router.push('/inscripciones#recomendados')"
            v-if="bannerToShow === 'bannerForEmployees'"
        >
          <div class="icon">
            <img src="/assets/img/icons/line/notificaciones.svg" alt="Notificación" />
          </div>
          <div class="text">
            Nuevas ofertas que se ajustan a tu perfil.
            <strong>Ver las ofertas</strong>.
          </div>
        </div>
        
        <div
            id="companies-banner-202309"
            class="banner-panel"
            @click="$router.push('/empleo/nuevo')"
            v-if="bannerToShow === 'bannerForEmployers'"
        >
          <div class="icon">
            <img src="/assets/img/icons/line/crear-oferta.svg" alt="Notificación" />
          </div>
          <div class="text">
            Te ayudamos a contratar los profesionales que necesitas para llevar a cabo tus proyectos o servicios.
            <br/><strong>¡Publica tus ofertas!</strong>
          </div>
        </div>
        
        <div
            id="users-banner-202309"
            class="banner-panel"
            @click="$router.push('/empleo/nuevo')"
            v-if="bannerToShow === 'bannerForNewUsers'"
        >
          <div class="icon">
            <img src="/assets/img/icons/line/crear-oferta.svg" alt="Notificación" />
          </div>
          <div class="text">
            Los anuncios de trabajo o solicitudes de presupuesto te ayudan a contactar con los usuarios que ofrecen los servicios que necesitas.
            <strong>¡Empieza ahora!</strong>
          </div>
        </div>

        <div
          id="applicants-banner-202608"
          class="banner-panel"
          @click="openHelp()"
          v-if="bannerToShow === 'bannerForApplicants'"
        >
          <div class="icon">
            <img src="/assets/img/icons/line/informacion.svg" alt="Ayuda" />
          </div>
          <div class="text">
            Necesitas ayuda para inscribirte en las ofertas de trabajo o solicitudes de presupuesto.<br/>
            <strong>¡Consulta nuestra guía!</strong>
          </div>
        </div>
                
      </div>
  `,
};
